import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { NativeSelect, NativeSelectOption } from "../components/ui/native-select"
import { cn } from "../lib/utils"

export function NativeSelectRenderer({ element }: RendererProps) {
  const { resolveSymbol, dispatchEvent } = useRenderContext()

  const rawOptions = (element as unknown as Record<string, unknown>).options
  const resolvedOptions = typeof rawOptions === "string" ? resolveSymbol(rawOptions) : rawOptions
  const options = Array.isArray(resolvedOptions)
    ? (resolvedOptions as Array<{ label?: string; value?: string }>)
    : []

  const defaultValue = element.defaultValue
    ? String(resolveSymbol(String(element.defaultValue)) ?? "")
    : undefined

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    dispatchEvent(element.id, "change", { value: e.target.value })
  }

  return (
    <NativeSelect
      className={cn(element.className)}
      defaultValue={defaultValue}
      onChange={handleChange}
    >
      {options.map((opt, i) => (
        <NativeSelectOption key={opt.value ?? i} value={opt.value ?? ""}>
          {String(resolveSymbol(opt.label ?? "") ?? "")}
        </NativeSelectOption>
      ))}
    </NativeSelect>
  )
}
